import { useHistory } from 'react-router-dom'
import { Button } from 'react-bootstrap'

import GoBackHeader from 'components/organisms/GoBackHeader'

import {
  LoginForgotAccountNotSetupContainer,
  LoginForgotAccountNotSetupTitle,
  LoginForgotAccountNotSetupButton
} from './styles'

function LoginForgotAccountNotSetup(): JSX.Element {
  const history = useHistory()

  return (
    <>
      <GoBackHeader text='Forgot Login Credentials' />
      <LoginForgotAccountNotSetupContainer>
        <LoginForgotAccountNotSetupTitle data-testid='forgot-account-not-setup-title'>
          You cannot reset your password because you have not completed setting
          up your client portal account
        </LoginForgotAccountNotSetupTitle>
        <p data-testid='forgot-account-not-setup-message'>
          Please find your client portal invite link that was either emailed to
          you and/or texted to you by your attorney and complete all the account
          creation steps. After you complete all the account creation steps then
          you can log into client portal from the login screen next time. If
          your client portal invite link has expired please have your attorney
          re-send a new client portal invite link to you.
        </p>

        <LoginForgotAccountNotSetupButton>
          <Button
            onClick={() => {
              history.push('/login')
            }}
            data-testid='forgot-account-not-setup-continue-button'
          >
            Continue
          </Button>
        </LoginForgotAccountNotSetupButton>
      </LoginForgotAccountNotSetupContainer>
    </>
  )
}

export default LoginForgotAccountNotSetup
